import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import jobPostsReducer from 'modules/JobPosts/reducer';
import {
  userCandidatesReducer,
  pendingCandidatesReducer,
  archivedCandidatesReducer,
} from 'modules/Candidates/reducer';
import statistics from 'modules/DashBoard/reducer';
import jobBoard from 'modules/JobBoard/reducer';
import admin from 'modules/Admin/reducer';
import messages from 'components/Modal/SendMessages/reducer';
import { user, allUsers } from './user';
import formStep from './formStep';
import persist from './persist';
import modal from './modal';
import loading from './loading';
import notes from './notes';
import notifications from './notifications';

const reducer = (history?: any) =>
  combineReducers({
    router: connectRouter(history),
    admin,
    user,
    allUsers,
    archivedCandidates: archivedCandidatesReducer,
    pendingCandidates: pendingCandidatesReducer,
    userCandidates: userCandidatesReducer,
    jobPosts: jobPostsReducer,
    jobBoard,
    modal,
    formStep,
    loading,
    notes,
    notifications,
    messages,
    statistics,
    _persist: persist,
  });

export default reducer;
